import { images } from '../constants';
import { FaCar, FaMoneyBillWave, FaRoad, FaFileAlt, FaTruck, FaTools } from 'react-icons/fa';

const process = [ 
    {
        id: 1,
        image: images.step1,
        icon: <FaCar />, // Car icon
        title: 'Car Selection',
        content: 'We help you find the perfect car that meets your needs and preferences from our wide selection.',
    },
    {
        id: 2,
        image: images.step2,
        icon: <FaMoneyBillWave />, // Financing icon
        title: 'Financing Options',
        content: 'Our team works with you to provide flexible financing options tailored to your budget and needs.',
    },
    {
        id: 3,
        image: images.step3,
        icon: <FaRoad />, // Test Drive icon
        title: 'Test Drive',
        content: 'We arrange a convenient test drive, giving you the opportunity to experience your chosen car.',
    },
    {
        id: 4,
        image: images.step4,
        icon: <FaFileAlt />, // Paperwork icon
        title: 'Paperwork',
        content: 'We assist you with all the necessary paperwork to finalize your purchase smoothly and hassle-free.',
    },
    {
        id: 5,
        image: images.step5,
        icon: <FaTruck />, // Delivery icon
        title: 'Delivery',
        content: 'We deliver your new car to your door or schedule a pickup at your convenience.',
    },
    {
        id: 6,
        image: images.step6,
        icon: <FaTools />, // After-sales service icon
        title: 'After-Sales Service',
        content: 'We offer continuous support, maintenance, and services to ensure your car is always in top condition.',
    },
];

export default process;